import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { PropietarioService } from '../../../../shared/services/propietarios.service';
import { EmpresasService } from '../../../../shared/services/empresas.service';
import { OrdenMantenimientoActividadesService } from '../../../../shared/services/orden-mantenimiento-actividades.service';
import { FormaPagoService } from '../../../../shared/services/forma_pago.service';
import { TipoAccion, TipoAccionService } from '../../../../shared/services/tipo_accion.service';
import { Propietario } from '../../../../shared/model/propietario';
import { MantenimientoService } from '../../../../shared/services/mantenimientos.service';
import swal from 'sweetalert2';
import { ActividadOrden } from '../../../../shared/model/historial-orden.model';
import { OrdenMantenimientoService } from '../../../../shared/services/orden-mantenimiento.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { DigitalesService } from '../../../../shared/services/digitales.service';
import { HttpEventType } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { AdministracionService } from '../../../../shared/services/administracion.services';
import { Administracion } from '../../../../shared/model/administracion.model';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';
import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
@Component({
  selector: 'app-gestionar-actividad',
  templateUrl: './gestionar-actividad.component.html',
  styleUrls: ['./gestionar-actividad.component.scss']
})
export class GestionarActividadComponent implements OnChanges {

@Input() orden: any = null;
@Input() actividad: any = null;
@Input() modoConsulta = false;

  @Output() cerrar = new EventEmitter<void>();

  @Output() guardar = new EventEmitter<{
    actividadId: number;
    datos: FormData;
  }>();

  @Output() actividadActualizada = new EventEmitter<void>();

  formResultadoActividad!: FormGroup;
  guardandoActividad = false;
  archivoFactura: File | null = null;
  evidenciasSeleccionadas: File[] = [];
  proveedores: any[] = [];
  personasResponsables: any[] = [];
  usuarioLogin: any;
  empresaTaller: any;
  conductor!: Propietario[];
  formapago: any;
  tipoaccion!: TipoAccion[];
  ordenSeleccionada: any = null;
  actividadesOrden: ActividadOrden[] = [];
  administraciones: Administracion[] = [];

  constructor(
    private fb: FormBuilder,
    private propietariosService: PropietarioService,
    private empresasService: EmpresasService,
    private forma_pagoService: FormaPagoService,
    private tipo_accionService: TipoAccionService,
    private matenimientosService: MantenimientoService,
    private OrdenMantenimientoActividadesService: OrdenMantenimientoActividadesService,
    private OrdenMantenimientoService: OrdenMantenimientoService,
    private authService: AuthService,
    private digitalesService: DigitalesService,
    private administracionesServices: AdministracionService
  ) {
    // console.log('HIJO: constructor ejecutado');
    this.inicializarFormulario();
    this.cargarDatosIniciales();
    this.usuarioLogin = this.authService.getCurrentUserValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('Orden recibida:', this.orden);
    // console.log('mantenimiento recibida:', this.orden.tipoMantenimiento);
   // console.log('Actividad recibida:', this.actividad);
   // console.log('Actividad id recibida:', this.actividad?.id);
    if (changes['actividad'] && this.actividad) {
      this.prepararFormulario();
    }

    if (changes['modoConsulta'] && this.formResultadoActividad) {
      this.actualizarModoFormulario();
    }
  }

  private inicializarFormulario(): void {
    this.formResultadoActividad = this.fb.group({
      resultado: ['REALIZADA', Validators.required],
      fecha_realizacion: [
        this.fechaLocalActual(),
        Validators.required
      ],
      kilometraje_ejecucion: [
        null,
        [Validators.required, Validators.min(0)]
      ],
      tipo_accion: ['', Validators.required],
      diagnostico: ['', Validators.required],
      trabajo_realizado: ['', Validators.required],
      trabajo_pendiente: [''],
      motivo_no_realizacion: [''],
      taller: [null],
      conductor: [null],
      factura: [''],
      idFormaPago: [''],
      valor_pagado: [null, Validators.min(0)],
      requiere_seguimiento: [false, Validators.required],
      descripcion_seguimiento: [''],
      observaciones: ['']
    });

    this.formResultadoActividad.get('resultado')!
      .valueChanges.subscribe(resultado => {
        this.actualizarValidacionesResultado(resultado);
      });

    this.formResultadoActividad.get('requiere_seguimiento')!
      .valueChanges.subscribe(requiere => {
        const control = this.formResultadoActividad.get(
          'descripcion_seguimiento'
        )!;

        if (requiere) {
          control.setValidators([Validators.required]);
        } else {
          control.clearValidators();
          control.setValue('');
        }

        control.updateValueAndValidity({ emitEvent: false });
      });
  }

  private cargarDatosIniciales(): void {
    this.cargarTaller();
    this.cargarConductor();
    this.cargarForma_pago();
    this.cargarTipo_accion();
    this.cargarDataAdmin();
  }

  private prepararFormulario(): void {
    this.archivoFactura = null;
    this.evidenciasSeleccionadas = [];

    this.formResultadoActividad.reset({
      resultado: 'REALIZADA',
      fecha_realizacion: this.fechaLocalActual(),
      kilometraje_ejecucion:
        this.actividad?.kilometraje_ejecucion ?? null,
      tipo_accion: this.actividad?.tipo_accion ?? '',
      diagnostico: this.actividad?.diagnostico ?? '',
      trabajo_realizado: this.actividad?.trabajo_realizado ?? '',
      trabajo_pendiente: this.actividad?.trabajo_pendiente ?? '',
      motivo_no_realizacion:
        this.actividad?.motivo_no_realizacion ?? '',
      proveedor_id: this.actividad?.proveedor_id ?? null,
      persona_responsable_id:
        this.actividad?.persona_responsable_id ?? null,
      factura: this.actividad?.numero_factura ?? '',
      forma_pago: this.actividad?.forma_pago ?? '',
      valor_pagado: this.actividad?.valor_pagado ?? null,
      requiere_seguimiento:
        this.actividad?.requiere_seguimiento ?? false,
      descripcion_seguimiento:
        this.actividad?.descripcion_seguimiento ?? '',
      observaciones: this.actividad?.observaciones ?? ''
    });

    this.actualizarValidacionesResultado(
      this.formResultadoActividad.get('resultado')!.value
    );

    this.actualizarModoFormulario();
  }

  private actualizarModoFormulario(): void {
    if (this.modoConsulta) {
      this.formResultadoActividad.disable({ emitEvent: false });
    } else {
      this.formResultadoActividad.enable({ emitEvent: false });
    }
  }

  get resultadoActual(): string {
    return this.formResultadoActividad.get('resultado')?.value;
  }

  get nombreActividad(): string {
    return this.actividad?.servicioRealizado?.nombre
      ?? this.actividad?.servicioRealizado?.tipo_de_mantenimiento
      ?? this.actividad?.nombre_actividad
      ?? this.actividad?.actividad
      ?? 'Actividad de mantenimiento';
  }

  get estadoModal(): string {
    return this.estadoCodigo(this.actividad)
      .replace(/_/g, ' ') || 'PENDIENTE';
  }

  get claseEstadoModal(): string {
    const clases: Record<string, string> = {
      PENDIENTE: '',
      EN_PROCESO: 'estado-proceso',
      PAUSADA: 'estado-pausada',
      FINALIZADA: 'estado-finalizada',
      CANCELADA: 'estado-cancelada',
      NO_REALIZADA: 'estado-no-realizada'
    };

    return clases[this.estadoCodigo(this.actividad)] ?? '';
  }

  get sistemaActividad(): string {
    return this.actividad?.servicioRealizado?.sistema ?? '';
  }

  get tipoMantenimientoNombre(): string {
    return this.orden?.tipoMantenimiento?.nombre
      ?? this.orden?.tipo_mantenimiento
      ?? 'No especificado';
  }

  get kilometrajeProgramado(): number {
    return Number(
      this.actividad?.km_base
      ?? this.actividad?.kilometraje_programado
      ?? 0
    );
  }

  private actualizarValidacionesResultado(resultado: string): void {
    const campos = [
      'kilometraje_ejecucion',
      'tipo_accion',
      'diagnostico',
      'trabajo_realizado',
      'trabajo_pendiente',
      'motivo_no_realizacion'
    ];

    campos.forEach(nombre => {
      this.formResultadoActividad.get(nombre)?.clearValidators();
    });

    if (resultado === 'NO_REALIZADA') {
      this.formResultadoActividad.get('motivo_no_realizacion')!
        .setValidators([Validators.required]);
    } else {
      this.formResultadoActividad.get('kilometraje_ejecucion')!
        .setValidators([Validators.required, Validators.min(0)]);

      this.formResultadoActividad.get('tipo_accion')!
        .setValidators([Validators.required]);

      this.formResultadoActividad.get('diagnostico')!
        .setValidators([Validators.required]);

      this.formResultadoActividad.get('trabajo_realizado')!
        .setValidators([Validators.required]);

      if (resultado === 'PARCIAL') {
        this.formResultadoActividad.get('trabajo_pendiente')!
          .setValidators([Validators.required]);
      }
    }

    campos.forEach(nombre => {
      this.formResultadoActividad.get(nombre)!
        .updateValueAndValidity({ emitEvent: false });
    });
  }

  campoInvalido(nombre: string): boolean {
    const control = this.formResultadoActividad.get(nombre);

    return !!control && control.invalid &&
      (control.touched || control.dirty);
  }

  private fechaLocalActual(): string {
    const fecha = new Date();
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');

    return `${anio}-${mes}-${dia}`;
  }

  estadoCodigo(actividad: any): string {
    return (
      actividad?.estadoActividadMantenimiento?.codigo
      ?? actividad?.estado_codigo
      ?? ''
    ).toUpperCase();
  }

  seleccionarFactura(event: Event): void {
    const input = event.target as HTMLInputElement;
    const archivo = input.files?.[0] ?? null;

    if (!archivo) return;

    const permitido = [
      'application/pdf',
      //'image/jpeg',
      //'image/png'
    ].includes(archivo.type);

    if (!permitido || archivo.size > 10 * 1024 * 1024) {
      alert('Adjunta un PDF, JPG o PNG de máximo 10 MB.');
      input.value = '';
      return;
    }

    this.archivoFactura = archivo;
    input.value = '';
    this.evidenciasSeleccionadas = [...this.evidenciasSeleccionadas, this.archivoFactura];
 //   console.log('Archivo de factura seleccionado:', this.evidenciasSeleccionadas);
   
  }

  seleccionarEvidencias(event: Event): void {
    const input = event.target as HTMLInputElement;
    const archivos = Array.from(input.files ?? []);
    const tipos = ['image/jpeg', 'image/png', 'image/webp'];

    const validos = archivos.filter(archivo =>
      tipos.includes(archivo.type) &&
      archivo.size <= 10 * 1024 * 1024
    );

    if (validos.length !== archivos.length) {
      alert('Solo se permiten imágenes de máximo 10 MB.');
    }

    this.evidenciasSeleccionadas = [
      ...this.evidenciasSeleccionadas,
      ...validos
    ].filter((archivo, indice, lista) =>
      lista.findIndex(item =>
        item.name === archivo.name && item.size === archivo.size
      ) === indice
    );

    input.value = '';
    console.log('Evidencias seleccionadas después de filtrar duplicados:', this.evidenciasSeleccionadas);
    console.log(this.orden.placa); //placa
    console.log("nit",this.administraciones[0].nit);
   
   

  }

  eliminarEvidencia(indice: number): void {
    this.evidenciasSeleccionadas =
      this.evidenciasSeleccionadas.filter((_, i) => i !== indice);
      console.log('Evidencias seleccionadas:', this.evidenciasSeleccionadas);
  }

  cerrarModal(): void {
    this.cerrar.emit();
  }

 guardarResultadoActividad(): void {
  if (this.formResultadoActividad.invalid) {
    this.formResultadoActividad.markAllAsTouched();
    return;
  }

  const form = this.formResultadoActividad.getRawValue();

  const payload = [
    {
      fecha: form.fecha_realizacion,
      placa: this.orden?.placa ?? '',
      km: Number(form.kilometraje_ejecucion ?? 0),

      idTipoMantenimiento: Number(this.orden.tipoMantenimiento.id),
      tipo: "",
      taller: form.taller ?? '',
      idServicio: Number(this.actividad?.actividad_id ?? 0),
      servicio: this.nombreActividad ?? '',
      idAccion: Number(form.tipo_accion ?? 0),
      accion: "",      
      factura: form.factura ?? form.numero_factura ?? '',
      idFormaPago: Number(form.idFormaPago ?? 0),
      forma: "",
      observacion: form.observaciones ?? '',
      conductor: form.conductor
        ? Number(form.conductor)
        : form.persona_responsable_id
          ? Number(form.persona_responsable_id)
          : null,

      vrpagos: Number(form.valor_pagado ?? 0),
      registro: new Date().toISOString(),
      estado: 1,
    }
  ];

  console.log('Payload enviado:', payload);

  this.guardandoActividad = true;
  const IdActividadProceso = 3;

this.guardandoActividad = true;


// verifica si tenemos soportes de factura
console.log('Evidencias seleccionadas:', this.evidenciasSeleccionadas);
 
  
this.matenimientosService.createMantenimiento(payload).subscribe({
  next: (response) => {
    console.log('Mantenimiento guardado:', response);
    console.log("ID RESPONSE",response.mantenimientos[0].id);
    const idMantenimiento = response.mantenimientos[0].id;
    let datosActividad = {
      fecha_inicio:  new Date().toISOString(),
      fecha_fin:  new Date().toISOString(),
      diagnostico: form.diagnostico ?? '',
      observacion: form.observaciones ?? '',
      trabajo_realizado: form.trabajo_realizado ?? '',
      kilometraje: Number(form.kilometraje_ejecucion ?? 0),
      usuario_ejecucion_id: this.usuarioLogin?.id ?? null,
      
    }
    if (response.codigo !== 0) {
      this.guardandoActividad = false;
      console.error('No se pudo guardar el mantenimiento:', response);
      return;
    }

    const idActividad = Number(this.actividad?.id);
    console.log('ID de la actividad:', idActividad);
    if (!idActividad) {
      this.guardandoActividad = false;
      console.error('No se encontró el ID de la actividad.');
      return;
    }

    console.log(
      'Actualizando estado de la actividad:',
      idActividad,
      'Nuevo estado:',
      IdActividadProceso
    );

    //actualizando el estado de la actividad
    this.OrdenMantenimientoActividadesService
      .gestionEstadoActividad(idActividad, IdActividadProceso,datosActividad)
      .subscribe({
        next: (respuestaEstado) => {
          console.log(
            'Estado de la actividad actualizado:',
            respuestaEstado
          );

          this.guardandoActividad = false;

          if (respuestaEstado && respuestaEstado.codigo === 0) {
            // Cerrar el modal cuando ambas operaciones sean exitosas.
         //  console.log('actividad actualizada:', respuestaEstado.data.id);
         //  console.log('orden :', this.orden.id);
            swal.fire('Éxito', 'Actividad gestionada correctamente', 'success');         
              // this.subirSoportes(
              //   [this.archivoFactura!],
              //   '901458283/mantenimientos/OOO777/1'
              // );

              if (this.evidenciasSeleccionadas.length>0){
                    this.subirSoportes(
                          this.evidenciasSeleccionadas,this.administraciones[0].nit + 
                           `/mantenimientos/` + 
                           (this.orden?.placa ?? '') +
                            `/` + idMantenimiento
                );
              }
          this.actividadActualizada.emit(this.orden.id);
            this.cerrarModal();
          }

  
          
        },
        error: (error) => {
          this.guardandoActividad = false;

          console.error(
            'El mantenimiento se guardó, pero no se pudo actualizar el estado:',
            error
          );
        }
      });
  },
  error: (error) => {
    this.guardandoActividad = false;

    console.error('Error al guardar el mantenimiento:', error);
  }
});

 }

  //Cargar los proveedores de talleres mecanicos
 
  
  //cargar las personas responsables
  private cargarTaller(): void {
    this.empresasService.getTaller().subscribe({
      next: (data) => (this.empresaTaller = data),
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarConductor(): void {
    this.propietariosService.getConductores().subscribe({
      next: (data) => (this.conductor = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener conductores:", error),
    });
  }

  private cargarForma_pago(): void {
    this.forma_pagoService.getFormasPago().subscribe({
      next: (data) => (this.formapago = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener forma de pago:", error),
    });
  }

  private cargarTipo_accion(): void {
    this.tipo_accionService.getAll().subscribe({
      next: (data) => (this.tipoaccion = data.data), // ✅ solo el array
      error: (error) =>
        console.error("❌ Error al obtener tipo de acción:", error),
    });
  }

    customSearchFn = (term: string, item: any) => {
    term = term.toLowerCase();

    const fullName = `${item.primernombre} ${item.segundonombre ?? ""} ${
      item.papellidos
    } ${item.seapellidos ?? ""}`.toLowerCase();
    const cedula = item.cedula?.toString().toLowerCase();

    return fullName.includes(term) || cedula.includes(term);
  };

cargarActividades(): void {
  this.OrdenMantenimientoService
    .getActividades(this.ordenSeleccionada.id)
    .subscribe({
      next: (response: any) => {
  
        // El servicio devuelve directamente un arreglo
        const actividades: ActividadOrden[] =
          Array.isArray(response) ? response : [];
  
        this.actividadesOrden = actividades;
  
        this.ordenSeleccionada = {
          ...this.ordenSeleccionada,
          actividadesOrden: actividades
        };

      },
      error: (error: any) => {
        console.error(
          'Error al obtener las actividades de la orden:',
          error
        );
  
        this.actividadesOrden = [];
  
        this.ordenSeleccionada = {
          ...this.ordenSeleccionada,
          actividadesOrden: []
        };
      }
    });
  }





subirSoportes(archivos: File[], basePath: string): void {
  if (!archivos?.length) {
    return;
  }

  const archivosPorCarpeta: { [carpeta: string]: File[] } = {};

  archivos.forEach(archivo => {
    const carpeta = archivo.type === 'application/pdf'
      ? `${basePath}/factura`
      : `${basePath}/imagenes`;

    if (!archivosPorCarpeta[carpeta]) {
      archivosPorCarpeta[carpeta] = [];
    }

    archivosPorCarpeta[carpeta].push(archivo);
  });

  const peticiones = Object.entries(archivosPorCarpeta).map(
    ([carpeta, archivosGrupo]) =>
      this.digitalesService.uploadMultiple(archivosGrupo, carpeta)
  );

  Swal.fire({
    title: 'Subiendo evidencias',
    html: 'Por favor espera mientras se cargan los archivos...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  forkJoin(peticiones)
    .pipe(
      finalize(() => {
        Swal.close();
      })
    )
    .subscribe({
      next: (respuestas) => {
       // console.log('Evidencias subidas correctamente:', respuestas);

        Swal.fire({
          icon: 'success',
          title: '¡Carga completada!',
          text: 'Todas las evidencias se subieron correctamente.',
          confirmButtonText: 'Aceptar'
        });
      },
      error: (error) => {
        console.error('Error al subir evidencias:', error);

        Swal.fire({
          icon: 'error',
          title: 'Error al subir evidencias',
          text: 'No fue posible completar la carga de todos los archivos.',
          confirmButtonText: 'Aceptar'
        });
      }
    });
}

private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
       // console.log(data);
          this.administraciones = data;               
        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }
  

 


}

